SA.createBuffered = function(fn, buffer) {
    var timer, scope, args,
        exec = function exec() {
            if (!(scope instanceof Ext.Base && scope.isDestroyed)) {
                fn.apply(scope, args);
            }
        };

    return function() {
        if (timer) {
            clearTimeout(timer);
        }

        scope = this;
        args = arguments;

        timer = setTimeout(exec, buffer);
    };
};

SA.leadingEdgeBuffer = function(fn, buffer) {
    var args,
        lastInvokeTime = 0,
        timer,
        scope,
        clear = function() {
            clearTimeout(timer);
            timer = null;
        },
        flush = function() {
            clear();

            if (args) {
                lastInvokeTime = Date.now();

                if (!(scope instanceof Ext.Base && scope.isDestroyed)) {
                    fn.apply(scope, args);
                }
            }

            args = null;
        },
        deferredFlush = function(delay) {
            clear();
            timer = setTimeout(flush, delay);
        },
        bufferedFn = function() {
            var now = Date.now();

            clear();

            args = arguments;
            scope = this;

            if (now - lastInvokeTime >= buffer) {
                flush();
            }
            else {
                deferredFlush(buffer);
            }

            lastInvokeTime = now;
        };

    bufferedFn.isBuffering = function() {
        return !!timer;
    };

    bufferedFn.clear = clear;

    bufferedFn.flush = flush;

    bufferedFn.deferredFlush = deferredFlush;

    return bufferedFn;
};